import { render, staticRenderFns } from "./Ai_mobile.vue?vue&type=template&id=746a608d&scoped=true&"
import script from "./Ai_mobile.vue?vue&type=script&lang=js&"
export * from "./Ai_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Ai_mobile.vue?vue&type=style&index=0&id=746a608d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746a608d",
  null
  
)

export default component.exports